import React, { useState } from "react";
import { Form, Input, Button, Card, Result, Spin, Alert } from "antd";
import { useParams, useHistory } from "react-router-dom";
import axiosInstance from "../axiosApi";

const UserSetPassword = () => {
  const { uid, token } = useParams<{ uid: string; token: string }>();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<React.ReactNode>(null);

  const onFinish = async (values: { new_password1: string; new_password2: string }) => {
    setLoading(true);
    try {
      await axiosInstance.post(`/api/reset/${uid}/set-password/`, {
        token,
        new_password1: values.new_password1,
        new_password2: values.new_password2,
      });
      setDone(true);
    } catch (err: any) {
      const detail: React.ReactNode =
        err?.response?.data?.token?.[0] ||
        err?.response?.data?.new_password2?.[0] ||
        err?.response?.data?.new_password1?.[0] ||
        err?.response?.data?.detail ||
        <>Could not reset password. The link may have expired. If issues persist, please submit a <a href={process.env.REACT_APP_SUPPORT} target="_blank" rel="noopener noreferrer">support ticket</a>.</>;
      setErrorMessage(detail);
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <Result
        status="success"
        title="Password updated"
        subTitle="You can now log in with your new password."
        extra={
          <Button type="primary" onClick={() => history.push("/login/")}>
            Go to Login
          </Button>
        }
      />
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "5rem" }}>
      <Card style={{ width: 360 }}>
        <h2 style={{ textAlign: "center", marginBottom: 24 }}>Set New Password</h2>
        <Spin spinning={loading}>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="New password"
              name="new_password1"
              rules={[{ required: true, message: "Please enter a new password" }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="Confirm new password"
              name="new_password2"
              dependencies={["new_password1"]}
              rules={[
                { required: true, message: "Please confirm your new password" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password1") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match"));
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            {showError && (
              <Form.Item>
                <Alert
                  message={errorMessage}
                  type="error"
                  showIcon
                  closable
                  onClose={() => setShowError(false)}
                />
              </Form.Item>
            )}
            <Button type="primary" htmlType="submit" loading={loading} block>
              Set Password
            </Button>
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

export default UserSetPassword;
